module.exports = __webpack_public_path__ + "img/add_photo_alternate.07325560.svg";